// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__("../node_modules/regenerator-runtime/runtime.js");
__webpack_require__("./inject-nonce.js");
var __webpack_exports__ = __webpack_require__("./bootstrap.js");
